import axios from 'axios';
import api_url from '../urls';
const actions = {

    allPolo (context, valor) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/polos',
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
          //   console.log(response);
            context.commit('GET_POLOS', response.data)
        })
        .catch((error) => {
            console.log(error);
        });
        
    },
   async addPolos (context, curso) {
        context.commit('PRELOADER_MUDAR',true)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
       await  axios.post(api_url.api_admin + 'v1/admin/polos',
        {
          nome: curso.fullName,
          tipo_curso_id: curso.tipo_curso_id,
          empresa_id: 1,
          status: 1
        }
        , {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
             console.log(response);
            context.commit('ADD_POLO', curso)
        })
        .catch((error) => {
            console.log(error);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
        
    }, 
    allGradePolo (context, value) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/oferta-grade-polo/get_join/'+ value.id,
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
             //console.log(response);
            context.commit('GET_GRADE_POLO', response.data)
        })
        .catch((error) => {
            console.log(error);
        });
        
    },
 async   addGradePolo (context, value) {
        context.commit('PRELOADER_MUDAR',true)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
      await   axios.post(api_url.api_admin + 'v1/admin/oferta-grade-polo',
        {
            nome: 'polo',
            oferta_grade_empresa_id: value.oferta_grade_empresa.id,
            polo_id: value.polo.id,
            data_abertura: value.data_abertura,
            data_encerramento: value.data_encerramento,
            empresa_id: 1,
            status: 1
        },
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
             console.log(response);
           // context.commit('ADD_GRADE_POLO', value)
        })
        .catch((error) => {
            console.log(error);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
        
    }, 

    cursosOfertaPolo (context, valor) {
console.log(valor)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/polos-curso/' + valor,
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
          //   console.log(response);
            context.commit('SET_POLOS_CURSO', response.data)
        })
        .catch((error) => {
            console.log(error);
        });
        
    },
}

export default actions